import { defineEntityOwner } from './types';

export const objectiveOwnerDescriptor = defineEntityOwner('objective', {
  owningService: 'reporting-store',
  clientPackage: '@tempo-io/backend-reporting-store-client',
  cdcTopic: 'reporting-store-data-changes',
  resolveLink: (entityId, ctx) =>
    ctx.loopId != null
      ? `/org-id/${ctx.organizationId}/loop/${ctx.loopId}/strategy?jumpToObjectiveId=${entityId}`
      : `/org-id/${ctx.organizationId}/objectives?jumpToObjectiveId=${entityId}`,
  resolveLabels: null,
});
